import script from "./AddMetadata.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddMetadata.vue?vue&type=script&lang=ts&setup=true"

import "./AddMetadata.vue?vue&type=style&index=0&id=4ed94849&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ed94849"]])

export default __exports__